import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-top-accent" aria-hidden="true" />
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand & Mission Column */}
          <div className="footer-brand-col">
            <Link to="/" className="footer-brand" onClick={scrollToTop}>
              <div className="footer-logo-frame">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/c/c3/Dr._Bhimrao_Ambedkar.jpg"
                  alt="Dr. B.R. Ambedkar Emblem"
                  className="footer-logo-img"
                />
              </div>
              <div className="footer-brand-text">
                <span className="footer-brand-title">Dr. Babasaheb Ambedkar</span>
                <span className="footer-brand-sub">Historical Archive & Monograph</span>
              </div>
            </Link>

            <p className="footer-mission-text">
              Dedicated to preserving and illuminating the scholarship, constitutional philosophy, and emancipatory legacy of modern India's foremost thinker and champion of human dignity.
            </p>

            <blockquote className="footer-mini-quote">
              "Life should be great rather than long."
            </blockquote>
          </div>

          {/* Core Biography Chapters */}
          <div className="footer-col">
            <h4 className="footer-col-heading">Life & Education</h4>
            <ul className="footer-nav-list">
              <li>
                <Link to="/dr-babasaheb-ambedkar-timeline" onClick={scrollToTop}>
                  Chronological Timeline
                </Link>
              </li>
              <li>
                <Link to="/dr-ambedkar-early-life-education" onClick={scrollToTop}>
                  Early Life & Roots (1891–1912)
                </Link>
              </li>
              <li>
                <Link to="/dr-ambedkar-international-education-columbia-lse" onClick={scrollToTop}>
                  Columbia University & LSE (1913–1923)
                </Link>
              </li>
              <li>
                <Link to="/dr-ambedkar-social-reform-movement" onClick={scrollToTop}>
                  Social Reform Movements
                </Link>
              </li>
            </ul>
          </div>

          {/* Historic Milestones & Statecraft */}
          <div className="footer-col">
            <h4 className="footer-col-heading">Statecraft & Rights</h4>
            <ul className="footer-nav-list">
              <li>
                <Link to="/mahad-satyagraha-dr-ambedkar-water-rights" onClick={scrollToTop}>
                  Mahad Satyagraha (1927)
                </Link>
              </li>
              <li>
                <Link to="/burning-manusmriti-dr-ambedkar-social-revolution" onClick={scrollToTop}>
                  Burning of Manusmriti (1927)
                </Link>
              </li>
              <li>
                <Link to="/dr-ambedkar-constitution-architect-contributions" onClick={scrollToTop}>
                  Constitutional Contributions
                </Link>
              </li>
              <li>
                <Link to="/dr-ambedkar-political-career-leadership" onClick={scrollToTop}>
                  Political Leadership & ILP
                </Link>
              </li>
              <li>
                <Link to="/dr-ambedkar-philosophy-teachings-buddhism" onClick={scrollToTop}>
                  Philosophy & Buddhism (1956)
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bespoke Archival Network & Developer Showcase Banner */}
        <div className="footer-credits-banner">
          <div className="credits-banner-main">
            {/* Left: Main Portal Link */}
            <div className="credits-portal-block">
              <div className="credits-portal-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
              </div>
              <div className="credits-portal-text">
                <span className="credits-portal-tag">Official Archive Network</span>
                <div className="credits-portal-link-wrap">
                  <span className="credits-portal-lbl">Main Website:</span>
                  <a
                    href="https://brambedkar.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="credits-portal-pill"
                    title="Open brambedkar.in in a new tab"
                  >
                    <span>brambedkar.in</span>
                    <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M7 17L17 7M17 7H7M17 7V17" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            {/* Right: Developer & Contact Badges */}
            <div className="credits-meta-items">
              <div className="credits-meta-card">
                <div className="credits-meta-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </div>
                <div className="credits-meta-info">
                  <span className="credits-meta-caption">Website Developer</span>
                  <span className="credits-meta-value">Prithviraj</span>
                </div>
              </div>

              <a
                href="mailto:prithvi.kamble7579@gmail.com"
                className="credits-meta-card credits-contact-link"
                title="Send inquiry to prithvi.kamble7579@gmail.com"
              >
                <div className="credits-meta-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect width="20" height="16" x="2" y="4" rx="2" />
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                  </svg>
                </div>
                <div className="credits-meta-info">
                  <span className="credits-meta-caption">Contact Email</span>
                  <span className="credits-meta-value credits-email-text">prithvi.kamble7579@gmail.com</span>
                </div>
                <span className="credits-mail-arrow" aria-hidden="true">↗</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom-bar">
          <div className="footer-copy-text">
            <p>
              &copy; {currentYear} Dr. Babasaheb Ambedkar Historical Archive. Curated for educational and research purposes.
            </p>
          </div>
          <button
            type="button"
            className="footer-back-to-top"
            onClick={scrollToTop}
            aria-label="Back to top of page"
          >
            <span>Back to top</span>
            <span aria-hidden="true">↑</span>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
